module.exports = __webpack_public_path__ + "img/img_2.dd2f4f65.png";